const EMPTY_VALUE = "—";
export {
  EMPTY_VALUE
};
